import React, { Component } from 'react';
import styled from 'styled-components';
import media from './MediaQueries';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { translate } from 'react-polyglot';
import csvDownload from '../shareModules/csvDownload';
import shareIcon from '../../images/instore/icons/share.svg';

const StyledShareButton = styled.button`
  cursor: pointer;
  width: 140px;
  height: 44px;
  background-color: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 4px;
  color: white;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.35s ease-in;
  left: 30px;
  z-index: 1;
  &:active {
    background-color: rgba(30, 144, 255, 0.3);
  }
  position: absolute;
  bottom: 160px;
  ${media.phone`
    top: 60px;
    width: 50px;
  `}

  .shareIcon {
    width: 50%;
    height: 26px;
    float: left;
    background-image: url(${shareIcon});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    ${media.phone`
      width: 100%;
    `}
  }
  .shareText {
    float: right;
    width: 50%;
    text-align: left;
    line-height: 26px;
    ${media.phone`
      display:none;
    `}
  }
`;

const StyledModulesModal = styled.div`
  font-size: 12px;
  width: 50%;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 20px;
  border-radius: 8px;
  position: absolute;
  left: 25%;
  bottom: 160px;
  color: white;
  ${media.phone`
    width: 80%;
    left: 10%;
    top: 120px;
    bottom: auto;
    padding: 10px;
  `}

  h1 {
    font-size: 14px;
    margin-bottom: 8px;
  }

  li {
    list-style-type: none;
  }

  .closeModal {
    float: right;
    cursor: pointer;
    font-weight: bolder;
  }

  .moduleLink {
    cursor: pointer;
    font-size: 14px;
  }
`;

const shareModules = {
  isw_cvsDownload: csvDownload,
};

class ShareButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModules: false,
    };
  }

  executeModule = module => {
    const { cvResults } = this.props;
    shareModules[module](cvResults);
  };

  render() {
    const { showModules } = this.state;
    const { options, t } = this.props;

    return (
      <div>
        <ReactCSSTransitionGroup
          transitionName="footerSlide"
          transitionAppear={true}
          transitionEnter={true}
          transitionLeave={true}
          transitionAppearTimeout={900}
          transitionLeaveTimeout={900}
          transitionEnterTimeout={900}
        >
          {showModules && (
            <StyledModulesModal className="revieve-modules-modal">
              <div
                className="closeModal"
                onClick={e => {
                  e.stopPropagation();
                  this.setState({ showModules: false });
                }}
              >
                {' '}
                X{' '}
              </div>
              {options.modules &&
                options.modules.map((module, i) => {
                  return (
                    <div className="moduleLink" key={'shareModule' + i} onClick={() => this.executeModule(module.name)}>
                      {t(module.text)}
                    </div>
                  );
                })}
            </StyledModulesModal>
          )}
        </ReactCSSTransitionGroup>
        <StyledShareButton
          onClick={() => {
            this.setState({ showModules: !showModules });
          }}
        >
          <div className="shareIcon"></div>
          <div className="shareText">{this.props.options.title}</div>
        </StyledShareButton>
      </div>
    );
  }
}

export default translate()(ShareButton);



// WEBPACK FOOTER //
// ./src/components/instore/ShareButton.js